import React from "react";
import { Icon } from "../../../_components";

const tooltipIcon = "fas fa-question-circle fa-fw";

export function CalendarEditorMonthsHeader({ tooltipContainer }) {
  const tooltipID =
    tooltipContainer !== undefined
      ? tooltipContainer
      : "chronosSetupModalTooltip";
  return (
    <div className="chronos-list-header">
      <div className="chronos-list-item-order text-center">#</div>
      <div className="chronos-calendar-month-name">
        <span className="chronos-calendar-month-label">Month Name</span>
      </div>
      <div className="chronos-calendar-month-days chronos-calendar-month-label">
        Days &nbsp;
        <Icon
          icon={tooltipIcon}
          data-for={tooltipID}
          data-tip="Default number of days in this month (not counting leap days)"
        />
      </div>
      {/* <div style={{ width: "0.5rem" }}></div> */}
      <div className="chronos-calendar-month-leapdays chronos-calendar-month-label">
        {/* {`Leap ${day}`} */}
        Leap Days &nbsp;
        <Icon
          icon={tooltipIcon}
          data-for={tooltipID}
          // data-tip={`Leap ${day} are added to the END of the month, when the year is a leap year for this month.`}
          data-tip={`Days added to the end of this month when applicable`}
        />
      </div>
      <div className="chronos-calendar-month-leapperiod chronos-calendar-month-label">
        Period &nbsp;
        <Icon
          icon={tooltipIcon}
          data-for={tooltipID}
          data-tip={`Number of years between two leap day occurrences`}
        />
      </div>
      <div className="chronos-calendar-month-controls text-center"></div>
    </div>
  );
}
